import {s_chars_mods} from "../_signals/s_chars_mods";
import {s_app_cid} from "../_signals/s_app";

export function charModsHasSource(source: string) {
    const cid = s_app_cid.value
    let mods = s_chars_mods.value.get(cid);
    let has = false;
    if (mods) {
        mods.forEach(m => {
            if (m.msource === source) {
                has = true;
                return;
            }
        });
    }
    return has
}

export function charModsGetMod(cid:string,mod: string) {
    let mods = s_chars_mods.value.get(cid);
    let modSum = 0;
    if (mods) {
        mods.forEach(m => {
            if (m.what === mod) modSum+=m.mmod
        });
    }
    return modSum
}